module.exports = __webpack_public_path__ + "img/world-background.fa3b8c07.svg";